import script from "./FAQComp.vue?vue&type=script&setup=true&lang=js"
export * from "./FAQComp.vue?vue&type=script&setup=true&lang=js"

import "./FAQComp.vue?vue&type=style&index=0&id=72a1149e&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72a1149e"]])

export default __exports__